import classNames from 'classnames';
import { observer } from 'mobx-react';

import useHomeWidgets from './hooks/useHomeWidgets';
import './HomeWidgets.scss';

export const HomeWidgets = observer(() => {
  const { widgets } = useHomeWidgets();

  return (
    <div
      className={classNames('home-widgets', {
        smaller: widgets.length > 4,
      })}
    >
      {widgets.map(({ Component: Widget, props, key, dataTestId }, index) => (
        <Widget key={key} dataTestId={`${dataTestId}-${index}`} {...props} />
      ))}
    </div>
  );
});
